import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RefreshToken } from 'planning-portal-library/src/lib/core/domain/models/refresh-token';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { catchError, map, Observable } from 'rxjs';
import { Authorize, LoginRequest } from '../../../../core/domain';
import { AccountRepository } from '../../../../core/repositories';
import { BaseResponse } from '../../../shared/base.response';
import { AccountApiUrls } from './account-api-urls';
import { AuthorizeWebEntity } from './entities/authorize.web-entity';
import { AuthorizeWebRepositoryMapper } from './entities/authorize.web-repository-mapper';

@Injectable({ providedIn: 'root' })
export class AccountWebRepository extends AccountRepository {
  authorizeMapper = new AuthorizeWebRepositoryMapper();
  environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  login(request: LoginRequest): Observable<Authorize> {
    return this.http
      .post<BaseResponse<AuthorizeWebEntity>>(
        `${this.environment.url}${AccountApiUrls.Login}`,
        request
      )
      .pipe(
        map((data: BaseResponse<AuthorizeWebEntity>) => {
          return data.result!;
        }),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.authorizeMapper.mapFrom));
  }
  override refreshToken(request: RefreshToken): Observable<Authorize> {
    return this.http
      .post<BaseResponse<AuthorizeWebEntity>>(
        `${this.environment.url}${AccountApiUrls.RefreshToken}`,
        request
      )
      .pipe(
        map((data: BaseResponse<AuthorizeWebEntity>) => {
          return data.result!;
        }),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.authorizeMapper.mapFrom));
  }
}
